/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
 import {  Component, ViewChild, ChangeDetectorRef } from '@angular/core';
 import {MessageService, Message} from 'primeng/api';
 import { ApiService } from '../../shared/api.service';
 import { CountriesService } from '../../@core/data/countries.service';
 import { FormBuilder, FormGroup,Validators} from '@angular/forms';
 import { NbDateService,NbDialogService,NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
 import { TermsComponent } from './terms.component';
 import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
 import {ConfirmationService} from 'primeng/api';
 import { ConfirmPassComponent } from './confirmPass.component';
 import { Router } from '@angular/router';
 import { MatStepper, MatSelectChange } from '@angular/material';
 //import { MatRadioModule } from '@angular/material';
 import { config } from './../../../../config';
 import { EducationalFormComponent } from './../../apply/dialog/educationalform.component';
 import { previewImg } from './../../apply/dialog/transcriptpreview.component';
 import { PaymentModelComponent } from './../../payment-success/payment.component';
 import { TranscriptDialogComponent } from './../../pages/myapplications/applicationsteps/dialog/transcriptdialogcomponent';
 import { saveAs } from 'file-saver';
 import {
	 NbAuthService,
	 NbAuthJWTToken
   } from '@nebular/auth';
 
 @Component({
   selector: 'nb-register',
   styleUrls: ['./register.component.scss'],
   templateUrl: './register.component.html',
   providers: [MessageService, ConfirmationService]
 })
 export class RegisterComponent{
	 
	 @ViewChild('stepper') stepper: MatStepper;
	 serverUrl = config.serverUrl;
	 imageUrl = config.imageUrl;
	 transUploadUrl = config.docUploadUrl;
	 emailIdOperational = config.emailIdOperational;
	 user_id
	 email:any;
	 RegisterForm: FormGroup;
	 alertflag = 0;///this is for  submit button
	 messgealertflag = 0;
	 messages;
	 validation_messages;
	 selectedGender;
	 selectedOption;
	 max = new Date();
	 date;
	 captcha;
	 country_id;
	 profile_info;
	 svg:SafeHtml;
	  captchaText;
	 values = '';
	 emailAlert = false;
	 display: boolean = false;
	 displayNo: boolean = false;
	 displayPrnNo: boolean = false;
	 prnValidation: boolean = false;
	 emailValue;
	 inputshow: boolean;
	 relation: string;
	 Hlabel: boolean;
	 Flabel: boolean;
 
	 Countries: any [];
	 selectedCountry :any;
	 permCountry:any;
 
	//  readonly emailValidate = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	//  readonly charValidate = /^[.a-zA-Z ]*$/;
	//  readonly spaceValidate = /^[.a-zA-Z]*$/;
	//  readonly postalValidate = /^[a-zA-Z0-9]+$/;
	//  readonly mobileValidate =/^[0-9]\d{5,12}$/;
	//  readonly numberpattern = /^[-+]?[0-9]+$/ ;
	//  readonly passwordValidate = /^[A-Za-z0-9!@#$%^&*()_]{6,}$/;
	//  readonly nospace = /^(?! )[A-Za-z ]*(?<! )$/;
 
	 //NEW REG
	 isLinear = false;
	 firstFormGroup : FormGroup;
	 secondFormGroup : FormGroup;
	 initials_gender;
	 thirdFormGroup : FormGroup;
	 fourthFormGroup : FormGroup;
	 fifthFormGroup : FormGroup;
	 sixthFormGroup : FormGroup;
	 seventhFormGroup : FormGroup;
	 eighthFormGroup : FormGroup;
	 whatsapp_no;
	 whatsapp_Code;
	 disable_checked = true;
	 sameWhatsapp = false;
	 countryradio = true;
	 country_name: any;
	 categoryradio;
	 prnradio;
	 phyHand;
	 prnUpload = false;
	 dobFlag: number = 0 ;
	 dobsplit: any;
 
	 position: string;
	 status1: string;
	 showNextButtonEdu = false;
	   educatonalData = [];
	 semestervalue:any;
	 
	 index: number;
	 loadingdoc = false;
	 showNextButton = false;
	 loading = false;
	   applicantFile = [];
	 documentListData = [];
 
	 //Payment tab start//
	 accessCode: any;
	 secureUrl: any;
	 encRequest: any;
	 //Payment tab end//
 
	 currenttoken;
	 loading1 = false;
	 loading2 = false;
	 loading3 = false;
	 loading4 = false;
	 loading5 = false;
	 loading6 = false;
	 loading7 = false;
	 loading8 = false;
	 loading9 = false;
	 loading10 = false;
	 loading11 = false;
	 loading12 = false;
	 loading13 = false;
	 loading14 = false;
	 loading15 = false;
	 loading16 = false;
	 Photo:any;
	 Sign:any;
	 Transfer:any;
	 Enrollment:any;
	 Bonafide:any;
	 PRN_Status_Report:any;
	 Enrollment_Letter_sample:any;
	 SemesterOne:any;
	 SemesterTwo:any;
	 SemesterThree:any;
	 SemesterFour:any;
	 SemesterFive:any;
	 SemesterSix:any;
	 SemesterSeven:any;
	 SemesterEight:any;
	 SemesterNine:any;
	 SemesterTen:any;
	 YearFirst:any;
  YearSecond:any;
  YearThird:any;
  YearFourth:any;
	 lastEducation;
 
	 current_date;
	 payment_before_error = false;
	 user_name: any;
	 emailPayment: any;
	 mobilePayment: any;
	 amountPayment: any;
 
	 firstname;
	 surname;
	 fathername;
	 mothername;
	 fathersurname;
	 mothersurname;
	 dob;
	 displayVideo1: boolean = false;
	 displayVideo2: boolean = false;
	 displayVideo3: boolean = false;
	 displayVideo4: boolean = false;
	 displayVideo5: boolean = false;
	 displayVideo6: boolean;
	 countryCode: any;
	 category;
	 reason;
	 test: boolean =true;
	errflag:boolean=false;
	 country_code: any;
	 country_codeL: any;
	 inputObj: any;
	 prnNoValidation: boolean;
	 categoryValidation: boolean=false;
	 current_location: string;
	 prnNoValidationError: boolean=false;
	 addresses: any;
	 areaLocation: any;
	 newaddress: any;
	 Category: string[] = ['General', 'OBC', 'SC', 'ST', 'EWS', 'VJA', 'NTB', 'NTC', 'NTD', 'SBC', 'SEBC', 'Others'];
	 
	   constructor(
		 private fb: FormBuilder,
		 protected dateService: NbDateService<Date>,
		 protected api : ApiService,
		 protected countries :CountriesService,
		 private dialogService: NbDialogService, //on submit dialog box
		 private messageService: MessageService,
		 private toastrService: NbToastrService,
		 private sanitizer: DomSanitizer,
		 private confirmationService: ConfirmationService,
		 private router : Router,
		 private ref: ChangeDetectorRef,
		 private authService: NbAuthService, 
	 ){  
		 this.Countries = this.countries.getData();
	 }
	 
	 ngOnInit() {
		if(this.inputObj){
			this.inputObj.setCountry(this.country_codeL);
		 }
		 this.api.getIpAddress().subscribe(data => {
			this.country_name = data['country'];
			if(data.country_name=='India'){
				this.current_location = 'WITHIN'
			}else{
				this.current_location="OUTSIDE";
			}
		});
		 var currentDate = new Date()
		 var day = currentDate.getDate()
		 var month = currentDate.getMonth() + 1
		 var year = currentDate.getFullYear()
		 this.current_date = day + "/" + month + "/" + year;
 
		 this.api.getCaptcha().subscribe((data: any) => {  
			 this.captchaText = data['data']['captchaText'];
			 this.captcha =  data['data']['captchadata'];
			 this.svg = this.sanitizer.bypassSecurityTrustHtml(this.captcha);         
			 err => console.error(err)
		 });
 
		 //NEW
		 this.firstFormGroup = this.fb.group({
			 firstNameCtrl: ['', [ Validators.required, Validators.maxLength(70),Validators.minLength(1)]], //Validators.pattern(this.charValidate),
			 LastNameCtrl: [''], //[ Validators.required, Validators.maxLength(70),Validators.minLength(1)] Validators.pattern(this.charValidate),
			 fatherNameCtrl: ['', [ Validators.required, Validators.maxLength(70),Validators.minLength(2)]], //Validators.pattern(this.spaceValidate),
			 motherNameCtrl: ['', [ Validators.required, Validators.maxLength(70),Validators.minLength(2)]], // Validators.pattern(this.spaceValidate),
			 fatherSurnameCtrl : [''], //[ Validators.required, Validators.maxLength(70),Validators.minLength(2)]
			 motherSurnameCtrl : [''], //, [ Validators.required, Validators.maxLength(70),Validators.minLength(2)]
		 });
 
		 this.secondFormGroup = this.fb.group({
			 genderCtrl: ['', Validators.required]
		 });
 
		 this.thirdFormGroup = this.fb.group({
			 addressCtrl: ['', Validators.required],
			 pincodeCtrl: ['', [ Validators.required, Validators.maxLength(10),Validators.minLength(5)]], //Validators.pattern(this.postalValidate),
			 cityCtrl: ['', [ Validators.required, Validators.maxLength(30),Validators.minLength(2)]],
			 districtCtrl: ['', [ Validators.required, Validators.maxLength(30),Validators.minLength(2)]],
			 stateCtrl: ['', [ Validators.required, Validators.maxLength(30),Validators.minLength(2)]],
		 });
 
		 this.fourthFormGroup = this.fb.group({
			//  prn_option : ['', [ Validators.required]],
			 input_prn : [''],
			 dobCtrl : ['', [ Validators.required]],
			categoryCtrl : [''],
			 reasonCtrl : ['', [ Validators.required]],
			//  certificateCtrl:['',[Validators.required]]
		 });
 
		 this.fifthFormGroup= this.fb.group({
			 emailCtrl : ['', [ Validators.required ]], //Validators.pattern(this.emailValidate)
			 passwordCtrl : ['',[Validators.required ]], //, Validators.pattern(this.passwordValidate)
			 repasswordCtrl : ['',[Validators.required ]], //, Validators.pattern(this.passwordValidate)
			 phoneCtrl:['', [ Validators.required ]], //, Validators.pattern(this.mobileValidate)
			 captchaCtrl:['', Validators.required],
		 });
 
		 this.sixthFormGroup = this.fb.group({
		 });
 
		 this.seventhFormGroup = this.fb.group({
			 passportSizePhotoCtrl : [''],
			 studSignCtrl : [''],
			 studTransferCtrl : [''],
			 studEnrollmentCtrl : [''],
			 studBonafideCtrl : [''],
			 prnStatusReportCtrl : [''],
			 SemesterOneCtrl : [''],
			 SemesterTwoCtrl : [''],
			 SemesterThreeCtrl : [''],
			 SemesterFourCtrl : [''],
			 SemesterFiveCtrl : [''],
			 SemesterSixCtrl : [''],
			 SemesterSevenCtrl : [''],
			 SemesterEightCtrl : [''],
			 SemesterNineCtrl : [''],
			 SemesterTenCtrl : [''],
			 YearFirstCtrl : [''],
      YearSecondCtrl : [''],
      YearThirdCtrl : [''],
      YearFourthCtrl : [''],
		 });
		 
		 this.eighthFormGroup = this.fb.group({
		 // 	fNPaymentCtrl : [''],
		 // 	mobilePaymentCtrl : [''],
		 // 	emailPaymentCtrl : [''],
		 // 	amountPaymentCtrl : ['']
		 });
 
	 }
 
 
	 ChangeStudentNamePop(){
		 this.confirmationService.confirm({
			 message: 'You cannot edit your name once registered.\n\nIf document(s) name & application name is mismatched, then application will be rejected.\n\n Click YES to proceed OR Click No to edit the name.',
			 header: 'Confirmation',
			 icon: 'pi pi-exclamation-triangle',
			 accept: () => {
				 this.firstFormGroup.get('firstNameCtrl').disable();
				 if(this.firstFormGroup.valid){
					this.test=true
					this.errflag=false
				}
				 
			 },
			 reject: () => {
				this.firstFormGroup.get('firstNameCtrl').enable();
				if(this.firstFormGroup.invalid){
					this.test=false
					this.errflag=true
				}
			 }
		 });
	 }
 
	 capitalize(text_value){
		 var text = text_value;
		 text = text.toLowerCase()
			 .split(' ')
			 .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
			 .join(' ');
		 return text;
	 }
 
	 ChangeStudentName(){
		 if(this.firstFormGroup.controls.LastNameCtrl.value){
			var value1 = this.capitalize(this.firstFormGroup.controls.LastNameCtrl.value);
			this.firstFormGroup.patchValue({
				LastNameCtrl : value1
			})

			this.fathersurname = this.firstFormGroup.controls.fatherSurnameCtrl.value ? this.firstFormGroup.controls.fatherSurnameCtrl.value : value1;
			this.mothersurname = this.firstFormGroup.controls.motherSurnameCtrl.value ? this.firstFormGroup.controls.motherSurnameCtrl.value : value1;
		 }
		 if(this.firstFormGroup.controls.fatherNameCtrl.value){
			 var value2 = this.capitalize(this.firstFormGroup.controls.fatherNameCtrl.value);
			 this.firstFormGroup.patchValue({
				 fatherNameCtrl : value2
			 })
		 }
		 if(this.firstFormGroup.controls.motherNameCtrl.value){
			 var value3 = this.capitalize(this.firstFormGroup.controls.motherNameCtrl.value);
			 this.firstFormGroup.patchValue({
				 motherNameCtrl : value3
			 })
		 }
		 if(this.firstFormGroup.controls.firstNameCtrl.value){
			 var value4 = this.capitalize(this.firstFormGroup.controls.firstNameCtrl.value);
			 this.firstFormGroup.patchValue({
				 firstNameCtrl : value4
			 })
		 }
	 }

	 ChangeParentsName(){
		if(this.firstFormGroup.controls.fatherSurnameCtrl.value){
			var value5 = this.capitalize(this.firstFormGroup.controls.fatherSurnameCtrl.value);
			this.firstFormGroup.patchValue({
				fatherSurnameCtrl : value5
			})
		}

		if(this.firstFormGroup.controls.motherSurnameCtrl.value){
			var value6 = this.capitalize(this.firstFormGroup.controls.motherSurnameCtrl.value);
			this.firstFormGroup.patchValue({
				motherSurnameCtrl : value6
			})
		}
	 }
 
	 ChangeAddress(){
		 if(this.thirdFormGroup.controls.addressCtrl.value){
			 var value1 = this.capitalize(this.thirdFormGroup.controls.addressCtrl.value);
			 this.thirdFormGroup.patchValue({
				 addressCtrl : value1
			 })
			 
		 }
	 }
 
	 radioChange(event) {
		 if(event){
			 if(event=='Male'){
				 this.initials_gender = "Mr.";
				 this.secondFormGroup.patchValue({
					 genderCtrl : event
				 })
			 }else if(event=='Female'){
				 this.initials_gender = "Ms.";
				 this.secondFormGroup.patchValue({
					 genderCtrl : event
				 })
			 }
		 }
		 //this.ref.detectChanges();
		 this.stepper.next();
	 }
 
	 radioChangepre() {
		 this.stepper.previous();
	 }
 
	 reloadcaptcha(){
		 this.api.getCaptcha()
		 .subscribe(
			 (data: any) => {  
			 this.captchaText = data['data']['captchaText'];
			 this.captcha =  data['data']['captchadata'];
			 this.svg = this.sanitizer.bypassSecurityTrustHtml(this.captcha);         
			 err => console.error(err)
		 });
	 }
 
	 checkcaptcha(duration,status){
		 if(!(this.fifthFormGroup.controls.captchaCtrl.value == this.captchaText)){		
			 this.toastrService.show(       
				 `checkcaptcha doesn't match ! ! `,`Error`,{status}
			   );
			 this.validation_messages =  "checkcaptcha doesn't match!";
			 this.fifthFormGroup.controls.captchaCtrl.markAsDirty();
			 
		 }
	 }
 
	 checkpassword(duration,status){
		 if(this.fifthFormGroup.controls.passwordCtrl.value != this.fifthFormGroup.controls.repasswordCtrl.value){		
 
			 this.toastrService.show(       
				 'Password doesnt match ! ! ', `Error`,{status}
			   );
			 this.validation_messages =  "Password doesn't match!";
			 this.fifthFormGroup.controls.passwordCtrl.markAsDirty();
		 }
	 }
 
	 onClose(){
		 this.messgealertflag = 0;
	 }
 
	 onEmailClose(){
		 this.emailAlert = false;
	 }
 
	 close() {
		 this.alertflag = 0;
	 }
 
	 //to check which form control is invalid
	 public findInvalidControls(controls) {
		 const invalid = [];
		
		 for (const name in controls) {
			 if (controls[name].invalid) {
				 invalid.push(name);
			 }
		 }
		 return invalid;
	   }
 
	 onProceed(duration,status){

		var check_validation;
		 this.fifthFormGroup.controls.emailCtrl.markAsDirty();
		 this.fifthFormGroup.controls.passwordCtrl.markAsDirty();
		 this.fifthFormGroup.controls.repasswordCtrl.markAsDirty();
		 this.fifthFormGroup.controls.phoneCtrl.markAsDirty();
		 this.fifthFormGroup.controls.captchaCtrl.markAsDirty();
 
		 var error=this.findInvalidControls(this.fifthFormGroup.controls)
		 
		 if(this.fifthFormGroup.controls.passwordCtrl.value == this.fifthFormGroup.controls.repasswordCtrl.value){
			 if(this.fifthFormGroup.valid){	
				 if(this.fifthFormGroup.controls.captchaCtrl.value == this.captchaText){	
					 check_validation = true;
					 this.alertflag = 0;
				 }else{
					 this.reloadcaptcha();
					 this.toastrService.show(       
						 `checkcaptcha doesn't match ! ! `, `Error`,{status}
					 );	
				 }			
			 }else{			
				 this.reloadcaptcha();			
				 check_validation = false;
				 this.alertflag = 1;
				 this.validation_messages =  "Fill in the all required details !";
			 }
		 }else{
			 this.alertflag = 1;
			 this.toastrService.show(       
				 `Password doesn't match ! ! `,`Error`,{status}
			 );
			 this.validation_messages =  "Password doesn't match!";
 
		 }
 
		 var phonecode = this.countryCode;
		 
		 
		 if(check_validation){
			//  if(this.fourthFormGroup.controls.prn_option.value == 'No'){
			// 	 this.prnUpload = true;
			//  }else{
			// 	 this.prnUpload = false;
			//  }
			 
			 if(this.sameWhatsapp){
				 var phonecode = this.countryCode
				 this.whatsapp_no = this.fifthFormGroup.controls.phoneCtrl.value;
				 this.whatsapp_Code = this.countryCode
			 }else{
				 this.whatsapp_no = null;
				 this.whatsapp_Code = null;
			 }
 
			 this.alertflag = 0;
			 this.dialogService.open(TermsComponent, {
				 context: {
					 userName : this.firstFormGroup.controls.firstNameCtrl.value,
					 Surname: this.firstFormGroup.controls.LastNameCtrl.value,
					 fatherName : this.firstFormGroup.controls.fatherNameCtrl.value,
					 motherName: this.firstFormGroup.controls.motherNameCtrl.value,
					 fatherSurname: this.firstFormGroup.controls.fatherNameCtrl.value ? this.firstFormGroup.controls.fatherSurnameCtrl.value : '',
					 motherSurname: this.firstFormGroup.controls.motherNameCtrl.value ? this.firstFormGroup.controls.motherSurnameCtrl.value : '',
					 Gender : this.secondFormGroup.controls.genderCtrl.value,
					 address : this.thirdFormGroup.controls.addressCtrl.value,
					 pincode : this.thirdFormGroup.controls.pincodeCtrl.value,
					 city : this.thirdFormGroup.controls.cityCtrl.value,
					 district : this.thirdFormGroup.controls.districtCtrl.value,
					 state : this.thirdFormGroup.controls.stateCtrl.value,
					//  radioprn : this.fourthFormGroup.controls.prn_option.value,
					 inputprn : this.fourthFormGroup.controls.input_prn.value,
					 userDob : this.fourthFormGroup.controls.dobCtrl.value,
					 category : this.category, //this.fourthFormGroup.controls.categoryCtrl.value,
					 reason : this.fourthFormGroup.controls.reasonCtrl.value,
					//  certificate : this.fourthFormGroup.controls.certificateCtrl.value,
					 userEmail : this.fifthFormGroup.controls.emailCtrl.value,
					 userPassword : this.fifthFormGroup.controls.passwordCtrl.value,
					 userCountryCode : this.countryCode,
					 userContactNo : this.fifthFormGroup.controls.phoneCtrl.value,
					 whatsapp_phoneCode : this.whatsapp_Code,
					 whatsapp_No : this.whatsapp_no,
					 current_location : this.current_location,
					 relation : this.relation,
				 },
			 }).onClose
			 .subscribe(
				 (user_id : any) => {
					 if(user_id){
						 this.user_id = user_id;
						 this.setEighthFormValue(this.user_id);
						 this.getRegisterValues();
						 this.getDocuments(this.user_id);
						 this.fifthFormGroup.get('emailCtrl').disable();
						 this.fifthFormGroup.get('passwordCtrl').disable();
						 this.fifthFormGroup.get('repasswordCtrl').disable();
						 this.stepper.next();
					 }
				 }
			 );
		 }else{
			 this.alertflag = 1;
			 if(this.validation_messages != null){
				 this.messages = this.validation_messages;
			 }else{
				 this.messages = "Your form is not filled please fill completely";
			 }
		 }
 
	 }
 
	 onKeyPress(event: any) {
		 this.emailAlert = false;		
		 this.api.emailValues(this.fifthFormGroup.controls.emailCtrl.value)
			 .subscribe(
				 (data: any) => {
				 if(data['status'] == 400){  
					 this.confirmationService.confirm({
						 message: 'Your email id is already exists in our database!!! Do you want to login on this website using same id and password??',
						 header: 'Confirmation',
						 icon: 'pi pi-exclamation-triangle',
						 accept: () => {
							 this.display = true;						
						 },
						 reject: () => {
							 this.emailValue = this.fifthFormGroup.controls.emailCtrl.value;
							 this.displayNo = true;
						 }
					 });
				 }else{
				 }       
				 err => console.error(err)
			 });
	 };
 
	 onNoSelect(event : any){
		 if(event.target.checked == true){
			 this.sameWhatsapp = true;
		 }else{
			 this.sameWhatsapp = false;
		 }
	 }
 
	 pincodeChanges(event){
		 this.thirdFormGroup.get('cityCtrl').enable();
		 this.thirdFormGroup.get('districtCtrl').enable();
		 this.thirdFormGroup.get('stateCtrl').enable();
		 this.api.checkPinValues(this.thirdFormGroup.controls.pincodeCtrl.value)
		 .subscribe(
			 (data: any) => {
				 if(data['status'] == 200){
					
					
					 this.addresses = data['data']
					//  var city = this.capitalize(data['data'].office_name);
					//  var district = this.capitalize(data['data'].district_name);
					//  var state = this.capitalize(data['data'].state_name);
					//  this.thirdFormGroup.patchValue({
					// 	 cityCtrl : city
					//  })
					//  this.thirdFormGroup.patchValue({
					// 	 districtCtrl : district
					//  })
					//  this.thirdFormGroup.patchValue({
					// 	 stateCtrl : state
					//  })
					//  this.thirdFormGroup.get('cityCtrl').disable();
					//  this.thirdFormGroup.get('districtCtrl').disable();
					//  this.thirdFormGroup.get('stateCtrl').disable();
				 }else{
					 this.thirdFormGroup.patchValue({
						 cityCtrl : ''
					 })
					 this.thirdFormGroup.patchValue({
						 districtCtrl : ''
					 })
					 this.thirdFormGroup.patchValue({
						 stateCtrl : ''
					 })
				 }
		 })
	 }

	 onChangeAreaLocation(location,district, state){
		this.areaLocation=location;
	   
	   this.thirdFormGroup.patchValue({
		   districtCtrl : district
	   })
	   this.thirdFormGroup.patchValue({
		   stateCtrl : state
	   })
	}
 
	 // checkradio(category) {
	 // 	
	 // 	this.fourthFormGroup.patchValue({
	 // 		my_radio_option : category
	 // 	})
	 // }
 
	 checkradioprn(value) {
		 //this.fourthFormGroup.controls.input_prn.setValidators([ ]);
		 //this.fourthFormGroup.controls.input_prn.updateValueAndValidity();
		//  this.fourthFormGroup.get('input_prn').setValidators([ ]);
		//  this.fourthFormGroup.get('input_prn').updateValueAndValidity();
		//  this.fourthFormGroup.patchValue({
		// 	 prn_option : value
		//  })
		 if(value == 'Yes'){
			//  this.fourthFormGroup.get('input_prn').setValidators([ Validators.required, Validators.maxLength(16), Validators.minLength(11) ]); //Validators.pattern(this.numberpattern),
			//  this.fourthFormGroup.get('input_prn').updateValueAndValidity();
			 // this.fourthFormGroup.controls.input_prn.setValidators([ Validators.required, Validators.pattern(this.numberpattern), Validators.maxLength(16), Validators.minLength(16) ]);
			 // this.fourthFormGroup.controls.input_prn.updateValueAndValidity();
		 }
	 }
 
	 addEducationalDetails(id,user_id){
		 // var coursename;
		 // if(this.lastEducation){
		 // 	coursename = this.lastEducation.courseName;
		 // }else{
		 // 	coursename = '';
		 // }
		 
		 var paid_amount = 'false';
		 var admin_show = 'false';
		   this.dialogService.open(EducationalFormComponent, {
			 closeOnBackdropClick : false,
			 context: {
			   user_id : user_id,
			   edu_id : id,
			   //course_name : coursename,
			   amount_paid : paid_amount,
			   admin_show : admin_show
			 },
		   }).onClose
			   .subscribe(
			 (data: any) => {
				 if(data){
					 this.position = 'top-right';
					 this.status1 = 'success';
					 const config = {
						 position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
					 };
					 var yourMessage = 'Saved';
					 this.toastrService.show(yourMessage, 'Success', config);
				 }
				 this.api.getApplicantEducationalValues(user_id).subscribe(data => {
					 this.educatonalData = data['data']
					 
					 this.lastEducation = this.educatonalData[0];//this.educatonalData.pop();
					//
					 //
					 if(data['data'].length >= 1){
						 this.showNextButtonEdu = true
					 }else{
						 this.showNextButtonEdu = false
					 }
					 this.getDocuments(user_id);
				 })
			 }
		 )
	 }
 
	 onDeleteEducation(info){
		 var duration = 10000;
		 this.position = 'top-right';
		 this.status1 = 'success';
		 this.confirmationService.confirm({
			message: 'Are you sure you want to delete?',
			acceptLabel : "Yes",
			rejectLabel : "No",
			accept: () => {
				this.api.deleteEducation(info).subscribe(data => {
					var yourMessage = data['message']
					if(data['status'] == 200){
						this.status1 = 'success';
						const config = {
							position: NbGlobalPhysicalPosition.TOP_RIGHT
						};
						this.toastrService.show(" "+yourMessage,`Success`,config)
						this.api.getApplicantEducationalValues(this.user_id).subscribe(data => {
							this.educatonalData = data['data']
							this.lastEducation = this.educatonalData[0];//this.educatonalData.pop();
							//
							this.getDocuments(this.user_id);
							if(data['data'].length >= 1){
								this.showNextButtonEdu = true
							}else{
								this.showNextButtonEdu = false
							}
						})
					}
				})
			},reject :()=>{
				
			}
		  });
	 }
 
	 getData(event: MatSelectChange){
		 this.category = event.source.value;
		
		  this.categoryValidation=true;
	 }
	 onBeforeSend(event, LoadNo) {
		 if(LoadNo == '1'){
		   this.loading1 = true;
		 }else if(LoadNo == '2'){
		   this.loading2 = true;
		 }else if(LoadNo == '3'){
		   this.loading3 = true;
		 }else if(LoadNo == '4'){
		   this.loading4 = true;
		 }else if(LoadNo == '5'){
		   this.loading5 = true;
		 }else if(LoadNo == '6'){
		   this.loading6 = true;
		 }else if(LoadNo == '7'){
		   this.loading7 = true;
		 }else if(LoadNo == '8'){
		   this.loading8 = true;
		 }else if(LoadNo == '9'){
		   this.loading9 = true;
		 }else if(LoadNo == '10'){
		   this.loading10 = true;
		 }else if(LoadNo == '11'){
		   this.loading11 = true;
		 }else if(LoadNo == '12'){
		   this.loading12 = true;
		 }else if(LoadNo == '13'){
			 this.loading13 = true;
		 }else if(LoadNo == '14'){
			this.loading14 = true;
		}else if(LoadNo == '15'){
			this.loading15 = true;
		}else if(LoadNo == '16'){
			this.loading16 = true;
		}
		 this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
		   if (token.isValid()) {
			 this.currenttoken = token;
			 event.xhr.setRequestHeader("Authorization", `Bearer ` + this.currenttoken);
		   }
		 });
	 }
 
	 onUpload(event: any,LoadNo) {
		 const reader = new FileReader();
		 var duration = 10000;
		 this.index += 1;
		 this.position = 'top-right';
		 this.status1 = 'success';
		 const config = {
		   position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
		 };
		 //this.ngOnInit();
		 if (event.files && event.files.length) {
		   const [file] = event.files;
		   reader.readAsDataURL(file);
		   var json = JSON.parse(event.xhr.response);
		   var yourData = json.Data; // or json["Data"]
		   var yourStatus = json.status; // or json["Data"]
		   var yourMessage = json.message; // or json["Data"]
		   if(LoadNo == '1'){
			 this.loading1 = false;
		   }else if(LoadNo == '2'){
			 this.loading2 = false;
		   }else if(LoadNo == '3'){
			 this.loading3 = false;
		   }else if(LoadNo == '4'){
			 this.loading4 = false;
		   }else if(LoadNo == '5'){
			 this.loading5 = false;
		   }else if(LoadNo == '6'){
			 this.loading6 = false;
		   }else if(LoadNo == '7'){
			 this.loading7 = false;
		   }else if(LoadNo == '8'){
			 this.loading8 = false;
		   }else if(LoadNo == '9'){
			 this.loading9 = false;
		   }else if(LoadNo == '10'){
			 this.loading10 = false;
		   }else if(LoadNo == '11'){
			 this.loading11 = false;
		   }else if(LoadNo == '12'){
			 this.loading12 = false;
		   }else if(LoadNo == '13'){
			 this.loading13 = false;
		   }else if(LoadNo == '14'){
			this.loading14 = false;
			}else if(LoadNo == '15'){
				this.loading15 = false;
			}else if(LoadNo == '16'){
				this.loading16 = false;
			}
		   if (yourStatus == 200) {
			 this.getDocuments(this.user_id);
			 this.toastrService.show(yourMessage, 'Success', config);
		   } else if (yourStatus == 401) {
			this.toastrService.show(yourMessage, 'Success', config);
		   } else if (yourStatus == 400) {
			this.toastrService.show(yourMessage, 'Success', config);
		   }
		 }
	   }
	 
	 onSelect($event: any,value): void {
		 var maxFileSize =  5000000;
		 var imgArr = $event.files[0].name.split('.');
		 var extension = imgArr[imgArr.length - 1].trim();
		 if ($event.files[0].size > maxFileSize) {
			 this.confirmationService.confirm({
				 message: 'Maximum file size should be 5 MB.',
				 header: 'Invalid File Size',
				 icon: 'pi pi-info-circle',
				 rejectVisible : false,
				 acceptLabel: 'Ok'
			 });
		 }
 
		 if(value!=undefined && (extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='JPG' && extension!='JPEG' && extension!='PNG') ) {
			 this.confirmationService.confirm({
				 message: 'Please upload your transcript in .jpeg or .jpg or .png formats',
				 header: 'Invalid File Type',
				 icon: 'pi pi-info-circle',
				 rejectVisible : false,
				 acceptLabel: 'Ok'
			 });
		 }
		 
		 if(value==undefined && (extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='pdf' && extension!='JPG' && extension!='JPEG' && extension!='PNG' && extension!='PDF')){
			 this.confirmationService.confirm({
				 message: 'Please upload your transcript in .jpeg or .jpg or .png or .pdf formats',
				 header: 'Invalid File Type',
				 icon: 'pi pi-info-circle',
				 rejectVisible : false,
				 acceptLabel: 'Ok'
			 });
		 }
	 }
 
	 onErrorFileUpload(event: any,LoadNo){
		 if(LoadNo == '1'){
		   this.loading1 = false;
		 }else if(LoadNo == '2'){
		   this.loading2 = false;
		 }else if(LoadNo == '3'){
		   this.loading3 = false;
		 }else if(LoadNo == '4'){
		   this.loading4 = false;
		 }else if(LoadNo == '5'){
		   this.loading5 = false;
		 }else if(LoadNo == '6'){
		   this.loading6 = false;
		 }else if(LoadNo == '7'){
		   this.loading7 = false;
		 }else if(LoadNo == '8'){
		   this.loading8 = false;
		 }else if(LoadNo == '9'){
		   this.loading9 = false;
		 }else if(LoadNo == '10'){
		   this.loading10 = false;
		 }else if(LoadNo == '11'){
		   this.loading11 = false;
		 }else if(LoadNo == '12'){
		   this.loading12 = false;
		 }else if(LoadNo == '13'){
		   this.loading13 = false;
		 }else if(LoadNo == '14'){
			this.loading14 = false;
		}else if(LoadNo == '15'){
			this.loading15 = false;
		}else if(LoadNo == '16'){
			this.loading16 = false;
		}
		 var duration = 10000;
		   if (event.xhr.response == ""){
		   this.toastrService.show(
			 `Network Error. Please try again after some time.`,
			 { duration }
		 );
		 
		 }
		 console.error("onErrorFileUpload Event", event);
	   }
 
	 getDocuments(user_id){
		 this.api.getApplicantFiles(this.user_id).subscribe(data => {
			 this.applicantFile = data['data']
			 this.documentListData = data['documentListData'];
			   this.Photo = data['data']['Photo'];
			   this.Sign = data['data']['Sign'];
			   this.Transfer = data['data']['Transfer'];
			   this.Enrollment = data['data']['Enrollment'];
			   this.Bonafide = data['data']['Bonafide'];
			   this.PRN_Status_Report = data['data']['PRN_Status_Report'];
			   this.Enrollment_Letter_sample = data['data']['Enrollment_Letter_sample'];
			   this.SemesterOne = data['data']['SemesterOne'];
			   this.SemesterTwo = data['data']['SemesterTwo'];
			   this.SemesterThree = data['data']['SemesterThree'];
			   this.SemesterFour = data['data']['SemesterFour'];
			   this.SemesterFive = data['data']['SemesterFive'];
			   this.SemesterSix = data['data']['SemesterSix'];
			   this.SemesterSeven = data['data']['SemesterSeven'];
			   this.SemesterEight = data['data']['SemesterEight'];
			   this.SemesterNine = data['data']['SemesterNine'];
			   this.SemesterTen = data['data']['SemesterTen'];
			   this.YearFirst = data['data']['YearFirst'];
			   this.YearSecond = data['data']['YearSecond'];
			   this.YearThird = data['data']['YearThird'];
			   this.YearFourth = data['data']['YearFourth'];
			 if(data['showNextButton'] == true){
			   this.showNextButton = true
			 }else{
			   this.showNextButton = false
			 }
		   })
	 }
 
	 onView(imagename,imgType){
		 //
		 this.dialogService.open(previewImg, {
			 context: {
			 arr : imagename,
			 //arr : 'https://migration@hsncu.edu.in/uiserver/upload/transcript/20086/HywOaKlgI.pdf',
			 imgType : imgType
			 },
		 });
	 }
 
	 onDeleteDocument(name, user_id, transcriptId,no,filename){
		 var duration = 10000;
		 this.position = 'top-right';
		 this.status1 = 'success';
		 if(no == '1'){
			 this.loading1 = true;
		   }else if(no == '2'){
			 this.loading2 = true;
		   }else if(no == '3'){
			 this.loading3 = true;
		   }else if(no == '4'){
			 this.loading4 = true;
		   }else if(no == '5'){
			 this.loading5 = true;
		   }else if(no == '6'){
			 this.loading6 = true;
		   }else if(no == '7'){
			 this.loading7 = true;
		   }else if(no == '8'){
			 this.loading8 = true;
		   }else if(no == '9'){
			 this.loading9 = true;
		   }else if(no == '10'){
			 this.loading10 = true;
		   }else if(no == '11'){
			 this.loading11 = true;
		   }else if(no == '12'){
			 this.loading12 = true;
		   }else if(no == '13'){
			 this.loading13 = true;
		   }else if(no == '14'){
			this.loading14 = false;
			}else if(no == '15'){
				this.loading15 = false;
			}else if(no == '16'){
				this.loading16 = false;
			}
		 this.api.deleteApplicantFile(filename, user_id, transcriptId).subscribe(data => {
			 var yourMessage = data['message']
			 if(no == '1'){
				 this.loading1 = false;
			   }else if(no == '2'){
				 this.loading2 = false;
			   }else if(no == '3'){
				 this.loading3 = false;
			   }else if(no == '4'){
				 this.loading4 = false;
			   }else if(no == '5'){
				 this.loading5 = false;
			   }else if(no == '6'){
				 this.loading6 = false;
			   }else if(no == '7'){
				 this.loading7 = false;
			   }else if(no == '8'){
				 this.loading8 = false;
			   }else if(no == '9'){
				 this.loading9 = false;
			   }else if(no == '10'){
				 this.loading10 = false;
			   }else if(no == '11'){
				 this.loading11 = false;
			   }else if(no == '12'){
				 this.loading12 = false;
			   }else if(no == '13'){
				 this.loading13 = false;
			   }else if(no == '14'){
				this.loading14 = false;
				}else if(no == '15'){
					this.loading15 = false;
				}else if(no == '16'){
					this.loading16 = false;
				}
			 if(data['status'] == 200){
				 this.status1 = 'success';
				 const config = {
					 position: NbGlobalPhysicalPosition.TOP_RIGHT
				 };
				 this.toastrService.show(" "+yourMessage,`Success`,config)
				 this.getDocuments(this.user_id);
			 }
		 })
	 }
 
	 onUpdate(duration,status){
		 
		 var check_validation;
		 this.fifthFormGroup.controls.emailCtrl.markAsDirty();
		 this.fifthFormGroup.controls.passwordCtrl.markAsDirty();
		 this.fifthFormGroup.controls.repasswordCtrl.markAsDirty();
		 //this.fifthFormGroup.controls.dobCtrl.markAsDirty();
		 //this.fifthFormGroup.controls.phonecodeCtrl.markAsDirty();
		 this.fifthFormGroup.controls.phoneCtrl.markAsDirty();
 
		 var error=this.findInvalidControls(this.fifthFormGroup.controls)
		 
		 if(this.fifthFormGroup.controls.passwordCtrl.value == this.fifthFormGroup.controls.repasswordCtrl.value){
			 if(this.fifthFormGroup.valid){	
				 if(this.fifthFormGroup.controls.captchaCtrl.value == this.captchaText){	
					 check_validation = true;
					 this.alertflag = 0;
				 }else{
					 this.reloadcaptcha();
					 this.toastrService.show(       
						 `checkcaptcha doesn't match ! ! `,`Error`,{status}
					 );	
				 }			
			 }else{			
				 this.reloadcaptcha();			
				 check_validation = false;
				 this.alertflag = 1;
				 this.validation_messages =  "Fill in the all required details !";
			 }
		 }else{
			 this.alertflag = 1;
			 this.toastrService.show(       
				 `Password doesn't match ! ! `, `Error`,{status}
			 );
			 this.validation_messages =  "Password doesn't match!";
 
		 }
 
		 var phonecode = this.countryCode;//this.fifthFormGroup.controls.phonecodeCtrl.value.split("+");
		 if(check_validation){
			//  if(this.fourthFormGroup.controls.prn_option.value == 'No'){
			// 	 this.prnUpload = true;
			//  }else{
			// 	 this.prnUpload = false;
			//  }
			 
			 if(this.sameWhatsapp){
				 var phonecode = this.countryCode;//this.fifthFormGroup.controls.phonecodeCtrl.value.split("+");
				 this.whatsapp_no = this.fifthFormGroup.controls.phoneCtrl.value;
				 this.whatsapp_Code = this.countryCode;
			 }else{
				 this.whatsapp_no = null;
				 this.whatsapp_Code = null;
			 }
 
			 this.alertflag = 0;
			 var register_data ={
				 userName : this.firstFormGroup.controls.firstNameCtrl.value,
				 Surname: this.firstFormGroup.controls.LastNameCtrl.value,
				 fatherName : this.firstFormGroup.controls.fatherNameCtrl.value,
				 fatherSurname: this.firstFormGroup.controls.fatherNameCtrl.value ? this.firstFormGroup.controls.fatherSurnameCtrl.value : '',
				motherSurname: this.firstFormGroup.controls.motherNameCtrl.value ? this.firstFormGroup.controls.motherSurnameCtrl.value : '',
				 motherName: this.firstFormGroup.controls.motherNameCtrl.value,
				 Gender : this.secondFormGroup.controls.genderCtrl.value,
				 address : this.thirdFormGroup.controls.addressCtrl.value,
				 pincode : this.thirdFormGroup.controls.pincodeCtrl.value,
				 city : this.areaLocation,//this.thirdFormGroup.controls.cityCtrl.value,
				 district : this.thirdFormGroup.controls.districtCtrl.value,
				 state : this.thirdFormGroup.controls.stateCtrl.value,
				// radioprn : this.fourthFormGroup.controls.prn_option.value,
				 inputprn : this.fourthFormGroup.controls.input_prn.value,
				 userDob : this.fourthFormGroup.controls.dobCtrl.value,
				category : this.category,//this.fourthFormGroup.controls.categoryCtrl.value,
				reason : this.fourthFormGroup.controls.reasonCtrl.value,
				// certificate : this.fourthFormGroup.controls.certificateCtrl.value,

				 userEmail : this.fifthFormGroup.controls.emailCtrl.value,
				 userPassword : this.fifthFormGroup.controls.passwordCtrl.value,
				 userCountryCode : this.countryCode,
				 userContactNo : this.fifthFormGroup.controls.phoneCtrl.value,
				 whatsapp_phoneCode : this.whatsapp_Code,
				 whatsapp_No : this.whatsapp_no,
				 user_id : this.user_id
			 }
			 //
			 this.api.updateRegisterValues(register_data)
				 .subscribe(
				 (data: any) => {
					 var yourMessage = data['message'];
					 const config = {
						 position: NbGlobalPhysicalPosition.TOP_RIGHT
					 };
					 if(data['status'] == 200){
						 this.user_id=data['data'];
						 this.setEighthFormValue(this.user_id);
						 this.getRegisterValues();
						 //this.toastrService.show(" "+yourMessage,`Success`,config)
					 }else if(data['status'] == 400){                               
						 //console.error("error 400 ");
						 //this.toastrService.show(" "+yourMessage,`Success`,config)
					 }     
				 err => console.error(err)
			 });
				 
		 }else{
			 this.alertflag = 1;
			 if(this.validation_messages != null){
				 this.messages = this.validation_messages;
			 }else{
				 this.messages = "Your form is not filled please fill completely";
			 }
		 }
 
	 }
 
	 setEighthFormValue(user_id){
		 this.api.getApplicantData(user_id).subscribe(data => {
		   if(data['status']==200){
			 // this.thirdForm.patchValue({fNPaymentCtrl :  data['data']['user_name']})
			 // this.thirdForm.patchValue({emailPaymentCtrl :  data['data']['user_email']})
			 // this.thirdForm.patchValue({mobilePaymentCtrl :  data['data']['user_mobile']})
			 // this.thirdForm.patchValue({amountPaymentCtrl :  data['data']['amount']})
			 // 
			 this.user_name = data['data']['user_name'];
			 this.emailPayment =  data['data']['user_email'];
			 this.mobilePayment =  data['data']['user_mobile'];
			 this.amountPayment  =  data['data']['amount'];
		   }
		 });
	   }
 
	 async firstpayment(){
		 this.payment_before_error = false;
		 //if(this.showNextButtonEdu == true && this.showNextButton == true){
		   this.dialogService.open(PaymentModelComponent, {
			 closeOnBackdropClick : false,
			 context: {
			   user_id : this.user_id,
			   user_name : this.user_name,
			   emailPayment : this.emailPayment,
			   mobilePayment : this.mobilePayment,
			   amountPayment  : this.amountPayment
			 },
		   }).onClose
		   .subscribe(
			 (data: any) => {
			 }
		   )
		 //}else{
		 //  this.payment_before_error = true;
		 //}
	 }
 
 
	 preview(){
		 this.loading = true;
		 this.api.downloadForm('',this.user_id).subscribe( data => {
			 if(data['status'] == 200){
				 this.api.downloadFiles(this.user_id+"_preview.pdf",this.user_id)
				 .subscribe(data => {
				   this.loading = false;
				   saveAs(data, this.user_id+"_preview.pdf");
				 });
			 }else{
				 this.loading = false;
			 }
		 })
	 }
 
	 getRegisterValues(){
		 this.api.get_applicant_data(this.user_id).subscribe(data => {
			 if(data['status']==200){
				this.newaddress = data['data'][0]['address'];
			   this.firstname = data['data'][0]['name'];
			   this.surname = data['data'][0]['surname'];
			   this.fathername = data['data'][0]['fathername'];
			   this.mothername = data['data'][0]['mothername'];
			   this.fathersurname = data['data'][0]['fathersurname'];
			   this.mothersurname = data['data'][0]['mothersurname'];
			   //this.dob = data['data'][0]['dob'];
			 }
		 })
	 }
 
	 backToStart(){
		 this.stepper.selectedIndex = 0;
	 }
 
	 onChange(event){
		if(event){
			if(this.firstFormGroup.controls.fatherNameCtrl.value!='' && this.firstFormGroup.controls.fatherNameCtrl.value!=null && this.firstFormGroup.controls.fatherNameCtrl.value!=undefined && (this.firstFormGroup.controls.motherNameCtrl.value=='' || this.firstFormGroup.controls.motherNameCtrl.value==null || this.firstFormGroup.controls.motherNameCtrl.value==undefined)){
				this.firstFormGroup.get('motherNameCtrl').setValidators([ ]);
				this.firstFormGroup.get('motherNameCtrl').updateValueAndValidity();
				// this.firstFormGroup.get('motherSurnameCtrl').setValidators([ ]);
				// this.firstFormGroup.get('motherSurnameCtrl').updateValueAndValidity();
			}else if(this.firstFormGroup.controls.motherNameCtrl.value!='' && this.firstFormGroup.controls.motherNameCtrl.value!=null && this.firstFormGroup.controls.motherNameCtrl.value!=undefined && (this.firstFormGroup.controls.fatherNameCtrl.value=='' || this.firstFormGroup.controls.fatherNameCtrl.value==null || this.firstFormGroup.controls.fatherNameCtrl.value==undefined )){
				this.firstFormGroup.get('fatherNameCtrl').setValidators([ ]);
				this.firstFormGroup.get('fatherNameCtrl').updateValueAndValidity();
				// this.firstFormGroup.get('fatherSurnameCtrl').setValidators([ ]);
				// this.firstFormGroup.get('fatherSurnameCtrl').updateValueAndValidity();
			}else{
				var customPattern = '[A-Za-z]+';
				this.firstFormGroup.get('motherNameCtrl').setValidators([ Validators.required, Validators.maxLength(70),Validators.minLength(2),Validators.pattern(customPattern)]); //Validators.pattern(this.spaceValidate),
				this.firstFormGroup.get('motherNameCtrl').updateValueAndValidity();
				this.firstFormGroup.get('fatherNameCtrl').setValidators([ Validators.required, Validators.maxLength(70),Validators.minLength(2),Validators.pattern(customPattern)]); //Validators.pattern(this.spaceValidate),
				this.firstFormGroup.get('fatherNameCtrl').updateValueAndValidity();
				// this.firstFormGroup.get('fatherSurnameCtrl').setValidators([ Validators.required, Validators.maxLength(70),Validators.minLength(2),Validators.pattern(customPattern)]); //Validators.pattern(this.spaceValidate),
				// this.firstFormGroup.get('fatherSurnameCtrl').updateValueAndValidity();
				// this.firstFormGroup.get('motherSurnameCtrl').setValidators([ Validators.required, Validators.maxLength(70),Validators.minLength(2),Validators.pattern(customPattern)]); //Validators.pattern(this.spaceValidate),
				// this.firstFormGroup.get('motherSurnameCtrl').updateValueAndValidity();
			}
		}
	}
 
	 downloadLetter(){
		 var file_name = 'Bonafide letter.pdf'
		 this.api.downloadTemplate().subscribe(data => {
			 saveAs(data,file_name); 
		 })
	 }
 
	 open(EducationalDialogNo) {
		 if (EducationalDialogNo == 1) {
		   this.dialogService.open(TranscriptDialogComponent, {
			 closeOnBackdropClick : false,
			 context: {
			   user_id : this.user_id,
			 },
		   }).onClose
			 .subscribe(
			   (data: any) => {
				 this.getDocuments(this.user_id);
				 err => console.error(err)
			   })
		 } else {
		   console.error("Function Open () : invalid number ");
		 }
	 }
 
	 onKeyPressPRN(event: any) {
		if(this.fourthFormGroup.controls.input_prn.value.length>16||this.fourthFormGroup.controls.input_prn.value.length<11){
		
			this.prnNoValidationError=true
		 }else{
			 this.prnNoValidationError=false
		 }
		 this.api.prnValues(this.fourthFormGroup.controls.input_prn.value)
			 .subscribe(
				 (data: any) => {
				 if(data['status'] == 400){ 
					 this.prnValidation = true; 
					 var data = data['data'];
					 this.confirmationService.confirm({
						 message: 'Your PRN number is already exists in our database!!! Do you want to login on this website using same id and password??',
						 header: 'Confirmation',
						 icon: 'pi pi-exclamation-triangle',
						 accept: () => {
							 this.display = true;						
						 },
						 reject: () => {
							 this.emailValue = data.email ;
							 this.displayPrnNo = true;
						 }
					 });
				 }else{
					 this.prnValidation = false; 
				 }       
				 err => console.error(err)
			 });
	 };
 
	 videoPopup(no){
		 if(no == 1){
			 this.displayVideo1 = true;
		 }
		 if(no ==2){
			 this.displayVideo2 = true;
		 }
		 if(no == 3){
			 this.displayVideo3 = true;
		 }
		 if(no == 4){
			 this.displayVideo4 = true;
		 }
		 if(no == 5){
			 this.displayVideo5 = true;
		 }
		 if(no == 6){
			 this.displayVideo6 = true;
		}
	 }
 
	 onCountryChange(details){
		 this.countryCode = details.dialCode;
		 
	 }

	changeflag(){
		this.dobFlag = 0;
		var difference : any;
  		var dobYear : any;
  		var currentYear : any;
  		this.dobsplit = this.fourthFormGroup.controls.dobCtrl.value.split("/");
		var dobYear = this.dobsplit[2]
  		currentYear = new Date().getFullYear();
		difference = currentYear - dobYear;
		if(difference < 16){
			this.dobFlag = 1;
			this.fourthFormGroup.controls.dobCtrl.reset();
		}
	}  

	telInputObject(obj) {
		this.api.getIpAddress().subscribe(data => {
			this.country_name = data['country'];
			this.country_code=data['country_code']
			this.country_codeL=this.country_code.toLowerCase();
			this.inputObj = obj;
			this.inputObj.setCountry(this.country_codeL);
		
		})
	  }
	  OnlyNoAllowed(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		  
		  return false;
		}
		return true;
		}

		radioChangerelation(event){
			this.inputshow=true;
			   if(event){
				   if(event=='husband'){
					   this.Hlabel=true;
					   this.Flabel=false;
					   this.relation='husband';
				   }else if(event=='father'){
					   this.Flabel=true;
					   this.Hlabel=false;
					   this.relation='father';
				   }
			   }
			}
 }